import React from "react";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { ErrorMessages, Paths } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PillButton from "./common/PillButton";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import ErrorDisplay from "./ErrorDisplay";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 100;
`;

const HeaderText = styled.div`
  font-size: 16px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px;
  text-align: center;
`;

class CheckConfirmation extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      redirectPage: null,
      loaderActive: false,
    };
    this.checkEmailConfirmation = this.checkEmailConfirmation.bind(this);
  }

  async checkEmailConfirmation() {
    try {
      this.setState({ loaderActive: true });
      const response = await this.identityUserApi.isEmailConfirmed();
      if (response) {
        clearInterval(this.interval);
        this.setState({ redirectPath: Paths.YOUR_INFO });
      }
    } catch (err) {
      this.errorManager.addError(
        ErrorMessages.FAILED_TO_CHECK_EMAIL_CONFIRMATION
      );
      this.setState({ loaderActive: false });
    }
    this.setState({ loaderActive: false });
  }

  async resendConfirmationEmail() {
    try {
      this.setState({ loaderActive: true });
      const userResponse = await this.valhallaApi.getUserInfo();
      await this.identityApi.sendConfirmationEmail(userResponse.data.email);
    } catch (err) {
      this.errorManager.addError(
        ErrorMessages.FAILED_TO_SEND_EMAIL_CONFIRMATION
      );
      console.log(err);
    }
    this.setState({ loaderActive: false });
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Email Confirmation" />
        <SFLoader
          active={this.state.loaderActive}
          message="Checking for confirmation..."
        />
        <MainContentWrapper>
          <Wrapper>
            <HeaderText style={{ marginTop: 50 }}>
              Please check your email for a message from SafeFun.
              <br /> <br />
              Click on the link in the email to confirm your email address.
            </HeaderText>

            <PillButton
              primary
              onClick={() => this.resendConfirmationEmail()}
              style={{ marginTop: "40px", width: "200px", marginBottom: 30 }}
            >
              Resend Email
            </PillButton>

            {this.errorManager.getErrorCount() > 0 ? (
              <ErrorDisplay errorManager={this.errorManager} />
            ) : null}
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async componentDidMount() {
    this.interval = setInterval(() => this.checkEmailConfirmation(), 5000);
  }
}

export default CheckConfirmation;
